import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Conditional hydration:
//   • If scripts/prerender.mjs has snapshotted this page it stamps the
//     root with data-prerendered="true". In that case we HYDRATE.
//   • Otherwise (dev server, or production pages that were not
//     pre-rendered, or the static SEO fallback inside public/index.html)
//     we mount a fresh root and overwrite any existing children.
const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.dataset.prerendered === "true") {
  hydrateRoot(container, tree);
} else {
  // Clear any non-pre-rendered static fallback markup before mounting.
  container.innerHTML = "";
  createRoot(container).render(tree);
}
